import script from "./DashboardHeaderAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardHeaderAdmin.vue?vue&type=script&setup=true&lang=js"

import "./DashboardHeaderAdmin.vue?vue&type=style&index=0&id=2d7461fa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d7461fa"]])

export default __exports__